'use client';
import { useTranslations } from 'next-intl';
import { Dispatch, SetStateAction, useCallback } from 'react';

import { MultiSelect, SingleSelect } from '@dh/components';

import { TopicOption } from '@dh/hooks';
import { SortBy } from '@dh/utils';

import { FilterRow } from './styles';

type FilterSortProps = {
    options: TopicOption[];
    filterChangeAction: (selectedIds: string[]) => void;
    sortBy: SortBy;
    updateSortByAction: Dispatch<SetStateAction<SortBy>>;
    translationNamespace: 'companiesOverview' | 'projectOverview';
    disabled?: boolean;
};

export const TopicFilterSort = ({
    options,
    sortBy,
    filterChangeAction,
    updateSortByAction,
    translationNamespace,
    disabled = false
}: FilterSortProps) => {
    const t = useTranslations(translationNamespace);
    const t_filters = useTranslations('filtering');

    const handleSortChange = useCallback(
        (target: string) => updateSortByAction(() => target as SortBy),
        [updateSortByAction]
    );

    return (
        <FilterRow stretch>
            <MultiSelect
                name='topics'
                allOptions={options}
                placeHolder={t('filter_topics_placeholder')}
                onChange={filterChangeAction}
                disabled={disabled}
                noMaxWidth
            />
            <SingleSelect
                leadingText={t_filters('sort_by')}
                allOptions={[SortBy.Newest, SortBy.Oldest]}
                defaultSelectedOption={sortBy}
                onChange={handleSortChange}
                disabled={disabled}
            />
        </FilterRow>
    );
};
